// Testi verificati sulla dashboard il 2026-10-16 (vedi piano guide operative).
export default {
  slug: 'cartellino',
  module: 'timesheet',
  title: 'Il cartellino presenze',
  tile: 'Controlla il mese, correggi i giorni e trasmettilo allo studio.',
  minutes: 4,
  publishedAt: '2026-10-26T09:00:00.000Z',
  moduleLabel: 'Apri i cartellini',
  modulePath: 'timesheet',
  brief: {
    purpose: 'Vedere ogni mese ore, assenze e giornate da sistemare di ciascun dipendente.',
    who: 'Chi in azienda gestisce le presenze e le trasmette allo studio paghe.',
    when: 'Durante il mese per correggere, a fine mese per chiudere e trasmettere.',
  },
  steps: [
    {
      title: 'Scegli il mese e apri il cartellino',
      text: "Nella pagina dei cartellini scegli il periodo con «Mese e Anno», poi clicca la riga del dipendente. Dalla sua pagina puoi passare a un'altra persona scegliendola dall'elenco.",
      screen: 'cartellino-1',
      notes: ['«Mese e Anno»: il mese da controllare', 'Clicca la persona per aprire il suo calendario'],
    },
    {
      title: 'Leggi i colori dei giorni',
      text: 'Ogni giorno ha un colore: verde se è completo, arancio se ci sono ore da giustificare. Con «Legenda» rivedi il significato quando vuoi.',
      screen: 'cartellino-2',
      notes: ['Il giorno arancio chiede la tua attenzione'],
      tip: 'Devi giustificare più giorni insieme? Nella pagina del dipendente usa «Giustifiche multiple»; dall\'elenco, «Modifica multipla» vale per più persone.',
    },
    {
      title: 'Correggi un giorno',
      text: 'Clicca un giorno: a lato vedi il dettaglio. Con «Modifica cartellino» indichi ore e giustifiche; se la tua azienda usa le timbrature, con «Aggiungi timbratura» inserisci quella mancante. Poi premi «Salva».',
      screen: 'cartellino-3',
      notes: ['«Modifica cartellino»: ore e giustifiche', '«Aggiungi timbratura»: la timbratura che manca'],
      maxWidth: 480,
    },
    {
      title: 'Chiudi e trasmetti allo studio',
      text: 'Quando il mese è a posto premi «Chiudi». Nella scheda «Chiusi» usa «Verifica cartellini» per confermarli, poi dalla scheda «Confermati» premi «Trasmetti allo studio». I pulsanti «Chiudi» e «Riapri» compaiono se hai il permesso di chiudere i cartellini.',
      screen: 'cartellino-4',
      notes: [
        'Le schede mostrano a che punto è ogni cartellino',
        '«Trasmetti allo studio» si attiva quando tutti i cartellini del mese sono confermati',
      ],
    },
  ],
  faq: [
    {
      question: 'Posso modificare un mese già inviato?',
      answer: 'Sì: nella scheda «Inviati allo studio» premi «Richiedi riapertura». Lo studio paghe riceve la richiesta e riapre il periodo.',
    },
    {
      question: 'Perché un giorno è arancio se il dipendente era presente?',
      answer: "Di solito mancano delle ore o una timbratura rispetto all'orario previsto. Apri il giorno per vedere il dettaglio.",
    },
  ],
};
